/* added by philip: js snippet for correct star review badge display in recommeded products section and quick view drawer */

/* old code from judge.me support 
const observer78 = new MutationObserver(() => {
if(jdgm.customizeBadges) {
jdgm.customizeBadges();
}
});
observer78.observe(document.documentElement, { childList: true, subtree: true });
*/

/* new code improved by claude to prevent looping */
(function () {
  if (!document.body) return;
  let queued = false;
  const observer = new MutationObserver(function () {
    if (queued || typeof jdgm === 'undefined' || !jdgm.customizeBadges) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      observer.disconnect();
      jdgm.customizeBadges();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();